import { FormattedMessage } from 'react-intl';
import { centsToDollarString } from 'utils/price';
import MonarchResolver from '../../../monarch/MonarchResolver';
import { ValueReinforcementResult } from '../../../monarch/rules/valueReinforcement/types';
import { CouponForm } from './coupon-form';
import { OrderSummaryProps } from './types';

export const OrderSummary = ({
  isCreditPurchase,
  priceDetails,
  onApplyCoupon,
  onRemoveCoupon,
}: OrderSummaryProps) => {
  const { lineItemsTotalPrice, cartTotal, fractionDigits, cartDiscount } =
    priceDetails;

  const lineItemsPriceInDollars = centsToDollarString(
    lineItemsTotalPrice,
    fractionDigits,
  );

  const totalAmountInDollars = centsToDollarString(cartTotal, fractionDigits);

  const discountAmountInDollars = centsToDollarString(
    cartDiscount?.amount,
    fractionDigits,
  );

  const hasDiscountCode = !!cartDiscount?.discount?.code;

  return (
    <div>
      <h2 className="h5">
        <FormattedMessage
          id="payment.summary.heading"
          defaultMessage="Summary"
          description="Order Summary Heading"
        />
      </h2>
      <div className="d-flex flex-row justify-content-between">
        <FormattedMessage
          tagName="p"
          id="payment.summary.price.label"
          defaultMessage="Price"
          description="Price Label"
        />
        <p translate="no">{lineItemsPriceInDollars}</p>
      </div>
      {(cartDiscount?.amount ?? 0) > 0 && (
        <div className="d-flex flex-row justify-content-between">
          <FormattedMessage
            tagName="p"
            id="payment.summary.discount.label"
            defaultMessage="Discounts applied"
            description="Discounts Applied Label"
          />
          <p translate="no">-{discountAmountInDollars}</p>
        </div>
      )}
      {!isCreditPurchase && (
        <CouponForm
          cartDiscount={cartDiscount}
          hasDiscount={hasDiscountCode}
          onApplyCoupon={onApplyCoupon}
          onRemoveCoupon={onRemoveCoupon}
        />
      )}
      <div className="mt-3 d-flex flex-row justify-content-between font-weight-bold">
        <FormattedMessage
          tagName="p"
          id="payment.summary.total"
          defaultMessage="TOTAL"
          description="Order Total Heading"
        />
        <p translate="no">{totalAmountInDollars}</p>
      </div>
      <MonarchResolver<ValueReinforcementResult>
        experimentKey="valueReinforcement"
        variants={{
          control: <div>Control</div>,
          test: <div>Test</div>,
        }}
        fallbackVariant="control"
        Loader={<div>Loading...</div>}
      />
    </div>
  );
};
